import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
  ModalSheetTitle,
} from '@/components/ModalSheet'

export interface EditProDetailsDialogProps {
  showing: boolean
  onClose: () => void
  onSubmit: () => void
  isSubmitPending: boolean
  /**
   * The Pro details form.
   */
  children?: ReactNode
}

export function EditProDetailsDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  children,
}: EditProDetailsDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle>Edit Pro details</ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <ModalSheetSection spaced>{children}</ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Save"
            type="submit"
            variant="primary"
            onPress={onSubmit}
            isPending={isSubmitPending}
            testId="edit-pro-details-save-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
